import { useEffect, useState } from "react";
import axios from "axios";
import { Label } from "@/components/ui/label";
import { fmtMoney } from "@/components/JobValue";

const API = `${window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL}/api`;

export function JobQuotePicker({ customerId, value, onChange, job, jobType }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!customerId) { setOptions([]); return; }
    const token = localStorage.getItem("session_token");
    axios.get(`${API}/customers/${customerId}/quote-options`, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((r) => setOptions(r.data || []))
      .catch(() => setOptions([]));
  }, [customerId]);

  const picked = options.find((o) => o.lead_id === value);
  let preview = null;
  if (value === "none") preview = "Not counted toward revenue";
  else if (job?.job_value_source === "invoice") preview = `${fmtMoney(job.job_value)} from the invoice`;
  else if (picked) preview = `${fmtMoney(picked.total)} incl. tax`;
  else if (!value) {
    const booked = options.find((o) => o.lead_id === job?.lead_id);
    const unpaid = ["measure", "pickup", "reminder"].includes(jobType);
    if (booked && !unpaid) preview = `${fmtMoney(booked.total)} from the booked quote`;
  }
  else if (!value) preview = "No quote linked yet";

  const label = (o) => {
    const d = o.created_at ? new Date(o.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "2-digit" }) : "";
    return `${fmtMoney(o.total)} · ${d}${o.summary ? ` · ${o.summary}` : ""}`;
  };

  return (
    <div data-testid="job-quote-picker">
      <Label htmlFor="job-quote" className="font-inter font-semibold text-zinc-700">Attached Quote / Job Value (Admin Only)</Label>
      <select
        id="job-quote"
        data-testid="job-quote-select"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full h-12 rounded-md border border-zinc-200 bg-white px-3 text-sm"
      >
        <option value="">Auto (booked quote, if any)</option>
        {options.map((o) => <option key={o.lead_id} value={o.lead_id}>{label(o)}</option>)}
        <option value="none">No quote: measurement, pickup or unpaid visit</option>
      </select>
      {preview && <p className="text-xs text-zinc-500 mt-1" data-testid="job-quote-preview">{preview}</p>}
    </div>
  );
}
